import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import Grid from "@mui/material/Unstable_Grid2";
import {
  CssTableCell,
  CssTableRow,
  CssTableCellHead,
} from "../../styles/styled";
import IconButton from "@mui/material/IconButton";
import SortIcon from "@mui/icons-material/Sort";

import { DataContentChart, DataContentText } from "./chart";

function createData(item, detail) {
  return { item, detail };
}

export function Card6Statistics({
  setStatisticsColumns,
  statisticsRows,
  newrowHeader,
}) {
  const SxRow = {
    display: "flex",
    flexDirection: "row",
    paddingBottom: "4px",
  };

  const SxLeft = {
    width: "40%",
    textAlign: "left",
    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  };

  const SxRight = {
    width: "60%",
    textAlign: "right",
    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  };

  const rows = [];
  const row = [];
  let aryName = [];
  let aryDescription = [];
  let arrHeader = [];
  let arrHeaderType = [];
  let arrUniqueNum = [];
  let arrLoss = [];
  let arrMean = [];
  let arrStandard = [];
  let arrMedian = [];
  let arrMin = [];
  let arrMax = [];
  let unit = [];

  function get() {
    try {
      aryName = newrowHeader.item_names.split("[spl]");
      aryDescription = newrowHeader.item_descriptions.split("[spl]");
      arrHeader = statisticsRows.body.item.split("[spl]");
      arrHeaderType = statisticsRows.body.type.split(",");
      arrUniqueNum = statisticsRows.body.unique_num.split(",");
      arrLoss = statisticsRows.body.loss.split(",");
      arrMean = statisticsRows.body.mean.split(",");
      arrStandard = statisticsRows.body.standard.split(",");
      arrMedian = statisticsRows.body.median.split(",");
      arrMin = statisticsRows.body.min.split(",");
      arrMax = statisticsRows.body.max.split(",");
      unit = statisticsRows.body.unit.split("[spl]");

      for (let i = 0; i < aryName.length; i++) {
        rows.push(createData(aryName[i], aryDescription[i]));
      }
    } catch (e) {}
  }

  try {
    if (Object.keys(statisticsRows)) {
      get();
    }
  } catch (e) {}

  if (statisticsRows.statusCode === "204") {
    row.push(
      <TableHead>
        <CssTableRow>
          <CssTableCellHead style={{ border: "none" }} colSpan={9}>
            該当データがありません。
          </CssTableCellHead>
        </CssTableRow>
      </TableHead>
    );
  } else if (rows.length > 0) {
    for (var i = 0; i < rows.length; i++) {
      if (rows.length === 1 && arrHeader[i] === "") {
      } else {
        if (!isNaN(aryName.length)) {
          setStatisticsColumns(aryName.length);
        }
        row.push(
          <>
            <CssTableRow key={arrHeader[i]} style={{ width: "100%" }}>
              <CssTableCell
                className="body"
                component="th"
                scope="row"
                style={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-all",
                  width: "35%",
                }}
              >
                {arrHeader[i]}
              </CssTableCell>
              <CssTableCell style={{ minWidth: "80px", width: "10%" }}>
                {unit[i]}
              </CssTableCell>
              <CssTableCell style={{ minWidth: "80px", width: "10%" }}>
                {arrHeaderType[i]}
              </CssTableCell>
              <CssTableCell
                style={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-all",
                  width: "35%",
                }}
              >
                {rows[i].detail}
              </CssTableCell>
              <CssTableCell style={{ minWidth: "250px", width: "20%" }}>
                <Box>
                  <Grid sx={SxRow}>
                    <Typography sx={SxLeft}>ユニークな数</Typography>
                    <Typography sx={SxRight}>
                      {parseFloat(arrUniqueNum[i]).toFixed(2)}
                    </Typography>
                  </Grid>
                  <Grid sx={SxRow}>
                    <Typography sx={SxLeft}>欠損データ数</Typography>
                    <Typography sx={SxRight}>
                      {parseFloat(arrLoss[i]).toFixed(2)}
                    </Typography>
                  </Grid>
                  <Grid sx={SxRow}>
                    <Typography sx={SxLeft}>平均値</Typography>
                    <Typography sx={SxRight}>
                      {parseFloat(arrMean[i]).toFixed(2)}
                    </Typography>
                  </Grid>
                  <Grid sx={SxRow}>
                    <Typography sx={SxLeft}>標準偏差</Typography>
                    <Typography sx={SxRight}>
                      {parseFloat(arrStandard[i]).toFixed(2)}
                    </Typography>
                  </Grid>
                  <Grid sx={SxRow}>
                    <Typography sx={SxLeft}>中央値</Typography>
                    <Typography sx={SxRight}>
                      {parseFloat(arrMedian[i]).toFixed(2)}
                    </Typography>
                  </Grid>
                  <Grid sx={SxRow}>
                    <Typography sx={SxLeft}>最小</Typography>
                    <Typography sx={SxRight}>
                      {parseFloat(arrMin[i]).toFixed(2)}
                    </Typography>
                  </Grid>
                  <Grid sx={SxRow}>
                    <Typography sx={SxLeft}>最大</Typography>
                    <Typography sx={SxRight}>
                      {parseFloat(arrMax[i]).toFixed(2)}
                    </Typography>
                  </Grid>
                </Box>
              </CssTableCell>
            </CssTableRow>
          </>
        );
      }
    }
    aryName = "";
    aryDescription = "";
    arrHeader = "";
    arrHeaderType = "";
    arrUniqueNum = "";
    arrLoss = "";
    arrMean = "";
    arrStandard = "";
    arrMedian = "";
    arrMin = "";
    arrMax = "";
  }
  return row;
}

export function Card6RawContent({
  title,
  setColumns,
  setStatisticsColumns,
  contentRows,
  newrowHeader,
  updateContent,
  sortIndex,
  sortOrder,
}) {
  const row = [];
  const headerCells = [];
  let arrTitle = [];
  let aryName = [];
  let arrSubTitle = [];

  // 生データソート処理
  function sortRawDataList(rawDataList, type, index, order) {
    let tmpList = [];
    if (type === "text") {
      if (order === "ASC") {
        tmpList = rawDataList.sort((a, b) => {
          if (a[index] < b[index]) {
            return -1;
          } else {
            return 1;
          }
        });
      } else {
        tmpList = rawDataList.sort((a, b) => {
          if (a[index] > b[index]) {
            return -1;
          } else {
            return 1;
          }
        });
      }
    } else {
      if (order === "ASC") {
        tmpList = rawDataList.sort((a, b) => {
          return a[index] - b[index];
        });
      } else {
        tmpList = rawDataList.sort((a, b) => {
          return b[index] - a[index];
        });
      }
    }
    return tmpList;
  }

  function get() {
    try {
      aryName = newrowHeader.item_names.split("[spl]");
      for (const key of Object.keys(contentRows.body)) {
        const val = contentRows.body[key];
        if (key === "items") {
          arrTitle = val.split("[spl]");
        } else if (key === "types") {
          arrSubTitle = val.split(",");
        } else if (key !== "items" && key !== "types") {
          break;
        }
      }

      arrTitle.map((title, index) => {
        if (index === sortIndex) {
          headerCells.push(
            <CssTableCellHead
              style={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-all",
                minWidth: "120px",
                position: "relative", // 追加
              }}
            >
              <div style={{ width: "90%" }}>{title}</div>
              <div style={{ position: "absolute", bottom: 0, right: 0 }}>
                <IconButton
                  onClick={() => {
                    updateContent(index);
                  }}
                  style={{
                    color: "gray",
                  }}
                >
                  <SortIcon />
                </IconButton>
              </div>
            </CssTableCellHead>
          );
        } else {
          headerCells.push(
            <CssTableCellHead
              style={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-all",
                minWidth: "120px",
                position: "relative", // 追加
              }}
            >
              <div style={{ width: "90%" }}>{title}</div>
              <div style={{ position: "absolute", bottom: 0, right: 0 }}>
                <IconButton
                  onClick={() => {
                    updateContent(index);
                  }}
                  style={{
                    color: "white",
                  }}
                >
                  <SortIcon />
                </IconButton>
              </div>
            </CssTableCellHead>
          );
        }
        return null;
      });
    } catch (e) {}
  }
  function createObject(source, child) {
    try {
      var returnVal = [];
      for (let i = 0; i < source[child[0]].split("[spl]").length; i++) {
        var childVal = {};
        for (let j = 0; j < child.length; j++) {
          childVal[child[j]] = source[child[j]].split("[spl]")[i];
        }
        returnVal.push(childVal);
      }
      return returnVal;
    } catch (e) {}
  }

  function GetContentTabChart() {
    try {
      var chartData = createObject(contentRows.body, ["type", "label", "data"]);
      let row = [];
      for (var i = 0; i < chartData.length; i++) {
        if (chartData[i].type === "chart") {
          if (
            chartData[i].label.includes("N/A") ||
            chartData[i].data.includes("N/A")
          ) {
            row.push(<CssTableCell>N/A</CssTableCell>);
          } else {
            const lastIndex = chartData[i].label.split("[div]").length - 1;
            row.push(
              <CssTableCell
                key={"Chart-" + i}
                style={{
                  verticalAlign: "middle",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  textAlign: "center",
                }}
              >
                <DataContentChart
                  inLabels={chartData[i].label.split("[div]")}
                  inDatasets={chartData[i].data.split("[div]")}
                />
                <div
                  style={{
                    width: "230px",
                    margin: "0 auto",
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "0.7rem",
                        fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                      }}
                    >
                      {chartData[i].label.split("[div]")[0]}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: "0.7rem",
                        fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                      }}
                    >
                      {chartData[i].label.split("[div]")[lastIndex]}
                    </Typography>
                  </Box>
                </div>
              </CssTableCell>
            );
          }
        } else if (chartData[i].type === "text") {
          if (
            chartData[i].label.split("[div]").includes("N/A") ||
            chartData[i].data.split("[div]").includes("N/A")
          ) {
            row.push(<CssTableCell key={"Chart-" + i}>N/A</CssTableCell>);
          } else {
            row.push(
              <CssTableCell key={"Chart-" + i}>
                <DataContentText
                  inLabels={chartData[i].label.split("[div]")}
                  inDatasets={chartData[i].data.split("[div]")}
                />
              </CssTableCell>
            );
          }
        }
      }
      return <>{row}</>;
    } catch (e) {}
  }

  function GetContentTabTableUnit() {
    try {
      let row = [];

      for (const key of Object.keys(contentRows.body)) {
        const val = contentRows.body[key];
        if (val === null) {
          break;
        }
        if (
          key === "items" ||
          key === "type" ||
          key === "label" ||
          key === "data" ||
          key === "isNumber" ||
          key === "__typename"
        ) {
          continue;
        }
        var arrStats = val.split("[spl]");
        let cells = [];
        for (var i = 0; i < arrStats.length; i++) {
          if (i > 0) {
            cells.push(
              <CssTableCell key={key + "-" + i} style={{ textAlign: "right" }}>
                {"単位：" + arrStats[i]}
              </CssTableCell>
            );
          } else {
            cells.push(
              <CssTableCell
                key={arrStats[i]}
                component="th"
                scope="row"
                style={{
                  textAlign: "right",
                }}
              >
                {"単位：" + arrStats[i]}
              </CssTableCell>
            );
          }
        }
        row.push(<CssTableRow key={key}>{cells}</CssTableRow>);
        break;
      }
      return <>{row}</>;
    } catch (e) {}
  }

  function GetContentTabTableBody() {
    try {
      let row = [];

      // 生データ取り出し
      let rawDataType = contentRows.body.type.split("[spl]");
      let rawDataList = [];
      for (let keyName in contentRows.body) {
        if (
          keyName.startsWith("data") &&
          keyName !== "data" &&
          contentRows.body[keyName] !== null
        ) {
          rawDataList.push(contentRows.body[keyName].split("[spl]"));
        }
      }
      // index指定時はソート
      if (sortIndex !== -1) {
        rawDataList = sortRawDataList(
          rawDataList,
          rawDataType[sortIndex],
          sortIndex,
          sortOrder
        );
      }

      let isNumFlg = [];
      for (const key of Object.keys(contentRows.body)) {
        if (key === "isNumber") {
          let val = contentRows.body[key];
          isNumFlg = val.split(",");
        }
      }

      for (let i = 0; i < rawDataList.length; i++) {
        let key = "data" + ("000" + (i + 1)).slice(-3);
        let cells = [];
        for (let j = 0; j < rawDataList[i].length; j++) {
          if (j > 0) {
            if (isNumFlg[j] === "true") {
              cells.push(
                <CssTableCell
                  key={key + "-" + j}
                  style={{ textAlign: "right" }}
                >
                  {rawDataList[i][j]}
                </CssTableCell>
              );
            } else {
              cells.push(
                <CssTableCell key={key + "-" + j}>
                  {rawDataList[i][j]}
                </CssTableCell>
              );
            }
          } else {
            if (isNumFlg[j] === "true") {
              cells.push(
                <CssTableCell
                  key={rawDataList[i]}
                  component="th"
                  scope="row"
                  style={{ textAlign: "right" }}
                >
                  {rawDataList[i][j]}
                </CssTableCell>
              );
            } else {
              cells.push(
                <CssTableCell key={rawDataList[i]} component="th" scope="row">
                  {rawDataList[i][j]}
                </CssTableCell>
              );
            }
          }
        }
        row.push(<CssTableRow key={key}>{cells}</CssTableRow>);
      }
      return <>{row}</>;
    } catch (e) {}
  }

  try {
    if (Object.keys(contentRows.body)) {
      get();
    }
  } catch (e) {}
  if (contentRows.statusCode === "204") {
    row.push(
      <TableHead>
        <CssTableRow>
          <CssTableCellHead style={{ border: "none" }} colSpan={9}>
            該当データがありません。
          </CssTableCellHead>
        </CssTableRow>
      </TableHead>
    );
  } else if (arrTitle.length > 0) {
    for (var i = 0; i < arrTitle.length; i++) {
      if (arrTitle.length === 1 && arrTitle[i] === "") {
      } else {
        if (!isNaN(arrTitle.length)) {
          setColumns(arrTitle.length);
          setStatisticsColumns(aryName.length);
        }
        row.push(
          <>
            <TableHead>
              <CssTableRow>{headerCells}</CssTableRow>
            </TableHead>
            <TableBody key={title + "-body"} style={{ overflow: "auto" }}>
              <GetContentTabChart />
              <GetContentTabTableUnit key={title + "-bodyunit"} />
              <GetContentTabTableBody key={title + "-bodyinner"} />
            </TableBody>
          </>
        );
        break;
      }
    }
  }
  return row;
}
